import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BreadCrumb.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/campaigns/detail/CampaignCountdown.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/campaigns/detail/CampaignDetailForms.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/campaigns/detail/CampaignInfo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/campaigns/detail/CampaignSwiper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VirtualPvEvent.js");
